import React, { forwardRef } from 'react';
import withCGI from '../../common/cgi/Cgi';

const VisualizerIframe = withCGI((props) => {
  const { iframeUrl, iframeRef } = props;
  return (
    <iframe
      className="more-views__visualizer-iframe"
      src={iframeUrl}
      ref={iframeRef}></iframe>
  );
});

const MoreViewsVisualizer = forwardRef((props, ref) => {
  return <VisualizerIframe iframeRef={ref} {...props} />;
});

MoreViewsVisualizer.displayName = 'MoreViewsVisualizer';

export default MoreViewsVisualizer;
